import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/css-fonts/plein.css'
import '@/assets/css/root.css'

createApp(App)
    .use(router)
    .mount('#app')
